import type { IconDef } from '../types';

export const flag: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M20.39 2.88C19.82 2.43 19.07 2.28 18.35 2.47C16.84 2.85 15.07 3.18 13.16 2.16C10.7 0.83 7.79 0.7 5 1.73V1C5 0.45 4.55 0 4 0C3.45 0 3 0.45 3 1V3.25V12.32V23C3 23.55 3.45 24 4 24C4.55 24 5 23.55 5 23V12.95C7.41 11.8 9.33 11.65 11.93 12.42C13.69 12.94 15.76 13.56 17.6 13.56C18.43 13.56 19.21 13.44 19.91 13.13C20.73 12.76 21.26 11.94 21.26 11.04V4.65C21.26 3.95 20.94 3.3 20.39 2.88ZM19.09 11.34C19.08 11.45 19.01 11.56 18.91 11.6C17.32 12.23 14.45 11.24 12.27 10.49C11.08 10.08 9.96 9.85 8.87 9.8C7.59 9.74 6.33 9.94 5 10.4V7.14L5.16 3.56C7.68 2.55 10.27 2.67 12.37 3.91C14.73 5.31 16.94 5.11 18.97 4.69C19.14 4.66 19.24 4.73 19.28 4.76C19.37 4.84 19.37 4.93 19.37 4.96L19.09 11.34Z',
    },
  ],
};
